<template xmlns:>
  <div class="page-header-index-wide transparent-area-appear">
    <a-row :gutter="24" :style="{ padding: '20px 20px 0px' }">
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" class="head-card-box" style="background-color: #009cfa">
          <div class="card-title">
<!--            <img src="@/assets/daiban.png" style="width: 24px;height: 24px;margin-right: 10px" alt=""/>-->
            <span>小叮当提醒学生</span>
          </div>
          <div class="card-content">
            <div class="flex-column skip-btn" @click="skipPreviewPage(1)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.moodReminder"/>
              <span class="item-desc">情绪提醒</span>
            </div>
            <div class="flex-column skip-btn" style="transform: translateX(-40px);"  @click="skipPreviewPage(1, 'disposalReminders')">
              <CountAnimation class="item-value" :end-val="overviewCardObj.handlingReminders"/>
              <span class="item-desc">已处理提醒</span>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" class="head-card-box" style="background-color: #F56B60">
          <div class="card-title">
            <span>重点关爱学生</span>
          </div>
          <div class="card-content">
            <div class="flex-column skip-btn"  @click="skipPreviewPage(2)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.careStudent"/>
              <span class="item-desc">重点关爱学生数</span>
            </div>
            <div class="flex-column skip-btn" style="transform: translateX(-40px);"  @click="skipPreviewPage(2)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.waitingCareStudent"/>
              <span class="item-desc">待关爱学生</span>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" class="head-card-box" style="background-color: #725BE9">
          <div class="card-title">
            <span>心理测评</span>
          </div>
          <div class="card-content">
            <div class="flex-column skip-btn"  @click="skipPreviewPage(3)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.planCount"/>
              <span class="item-desc">待完成</span>
            </div>
            <div class="flex-column skip-btn" style="transform: translateX(-40px);"  @click="skipPreviewPage(4)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.assessmentCount"/>
              <span class="item-desc">待评估</span>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="6" :style="{ marginBottom: '24px' }">
        <a-card :loading="loading" class="head-card-box" style="background-color: #13B999">
          <div class="card-title">
            <span>班级动态</span>
          </div>
          <div class="card-content">
            <div class="card-item skip-btn" @click="skipPreviewPage(5)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.happyCount"/>
              <span class="item-desc">愉悦人数</span>
            </div>
            <div class="card-item skip-btn" @click="skipPreviewPage(6)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.moodCount"/>
              <span class="item-desc">情绪记录</span>
            </div>
            <div class="card-item skip-btn" @click="skipPreviewPage(7)">
              <CountAnimation class="item-value" :end-val="overviewCardObj.activityCount"/>
              <span class="item-desc">校园活动</span>
            </div>
          </div>
        </a-card>
      </a-col>
    </a-row>
    <a-row :span="24" >
      <a-card :loading="loading" :bordered="false" >
        <a-row :gutter="[15, 15]" class="row-box">
          <a-col :xl="4" :lg="6" :md="9" :sm="24">
            <j-dict-select-tag
              placeholder="请选择班级"
              v-model="queryParam.classId"
              identityGet="classDict"
              :async="true"
              @setDefaultValue="setDefaultClass"
            />
          </a-col>
          <a-col :xl="4" :lg="6" :md="9" :sm="24">
            <a-range-picker :value="rangeDate" @change="onRangeChange" style="width: 100%;"/>
          </a-col>

          <a-col :span="2" v-for="(item, index) in searchItem" :key="index" class="tag-col">
            <div
              class="tag-item"
              :style="{borderLeft: `4px solid ${searchItemColor[index]}`}"
            >
              <span class="tag-name">{{ item }}</span>
              <a-icon class="delete-icon" type="close-circle" @click="deleteBtn(item, index)" />
            </div>
          </a-col>

          <a-col :span="3" v-if="contrastInputStatus" class="select-box">
            <a-select show-search style="width: 120px" :not-found-content="null" @search="handleSearch" @inputKeydown.enter="() => { contrastInputStatus = false }">
              <div slot="dropdownRender">
                <recycle-scroller
                  class="virtual-list"
                  :buffer="1000"
                  :prerender="200"
                  style="max-height: 200px"
                  :item-size="32"
                  key-field="period_id"
                  :items="keyword"
                >
                  <template v-slot="{ item, index }">
                    <div class="list-item" :key="index" @click="handleSelect(item.period_id)">
                      {{ item.name }}
                    </div>
                  </template>
                </recycle-scroller>
              </div>
            </a-select>
            <a-icon class="select-del-icon" type="close-circle" @click="() => { contrastInputStatus = false }" />
          </a-col>
          <a-col :span="3">
            <div style="display: flex;">
              <a-button  @click="addContrast" style="margin-right: 10px;"> + 添加对比 </a-button>
              <!-- <a-button type="primary" icon="import" style="margin-right: 10px;" @click="importTag">导入事件</a-button> -->
              <a-button type="primary" @click="chaDate" icon="search">查询</a-button>
            </div>
          </a-col>
        </a-row>
      </a-card>
    </a-row>

    <a-row>
      <a-col :span="24">
        <a-row>
          <a-col :span="17">
            <a-row>
              <a-col :span="24">
                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <div class="salesCard">
                    <LineChart title="班级情绪变化趋势" style="margin-bottom: 20px;" height="250px" :fields="moodField" :dataSource="schoolMood">
                      <template slot="titleExtra">
                        <a-button type="primary" class="add-btn" @click="addEventClick">添加事件</a-button>
                      </template>
                    </LineChart>
                  </div>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <div class="salesCard">
                    <LineChart title="班级情绪波动指数趋势" style="margin-bottom: 20px;" height="250px" :fields="volatilityIndex" :dataSource="schoolMoodSwings"/>
                  </div>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="leftCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <div class="salesCard">
                    <a-row>
                      <a-col :span="12">
                        <LineChart title="学生活跃度对比" :grid="grid" style="margin-bottom: 20px;" height="250px" :fields="['学生活跃度']" :dataSource="studentActivity"/>
                      </a-col>
                      <a-col :span="12">
                        <LineChart title="家长关注度对比" :grid="grid" style="margin-bottom: 20px;" height="250px" :fields="['家长活跃度']" :dataSource="parentVisit"/>
                      </a-col>
                    </a-row>
                  </div>
                </a-card>
              </a-col>
            </a-row>
          </a-col>
          <a-col :span="7">
            <a-row>
              <a-col :span="24" >
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="parentFollowList.title"
                    :columns="parentFollowList.columns"
                    :tableData="parentFollowList.tableData"
                  >
                    <template slot="phoneEmail" slot-scope="{record}">
                      <div style="display: flex;color: #1783EC;text-align: center;font-weight: bold;cursor: pointer;">
                        <div style="flex: 1;" @click="getParentPhone(record)">手机</div>
                        <div style="flex: 1;" @click="getParentEmail(record)">邮箱</div>
                      </div>
                    </template>
                  </TableList>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="recentMoodLowList.title"
                    :columns="recentMoodLowList.columns"
                    :tableData="recentMoodLowList.tableData"
                  >
                    <template slot="recentMoodLow" slot-scope="{ record }">
                      <span style="color: #86a3e5; cursor: pointer;" @click="viewCareList(record, 2)">查看</span>
                    </template>
                  </TableList>
                </a-card>
              </a-col>
              <a-col :span="24">
                <a-card class="RightCardBox" :loading="loading" :bordered="false" :style="{ marginBottom: '24px' }">
                  <TableList
                    :title="mainCareList.title"
                    :columns="mainCareList.columns"
                    :tableData="mainCareList.tableData"
                  >
                    <template slot="emotionalTrends" slot-scope="{record}">
                      <span style="color: #86a3e5; cursor: pointer;" @click="viewCareList(record, 2)">查看</span>
                    </template>
                  </TableList>
                </a-card>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <AddEventModal ref="addEventModal" @refresh="refreshMarked" />
    <ViewKeyPointModal ref="viewKeyPointModal" />
    <PhoneDetailModal ref="phoneDetailModal"/>
    <EmailDetailModal ref="emailDetailModal"/>
    <TemplateUploadFile ref="templateUploadFile" title="导入事件"/>
  </div>
</template>

<script>
import TableList from '@/components/chart/TableList'
import { getAction } from '@api/manage'
import LineChart from '@/components/echartZyz/components/LineChart'
import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
import moment from 'moment'
import { addLineCompare, deleteLineCompare, handleLineChartData, randomColor, simpleDebounce } from '@/utils/util'
import AddEventModal from '@/comUi/AddEventModal'
import ViewKeyPointModal from './compoents/ViewKeyPointModal'
import CountAnimation from '@/components/CountAnimation'
import PhoneDetailModal from './compoents/PhoneDetailModal'
import EmailDetailModal from './compoents/EmailDetailModal'
import TemplateUploadFile from '@/components/TemplateUploadFile'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css' // 引入它的 css
import { RecycleScroller } from 'vue-virtual-scroller'

export default {
  name: 'ClassMood',
  components: {
    JSearchSelectTag,
    TableList,
    AddEventModal,
    ViewKeyPointModal,
    CountAnimation,
    PhoneDetailModal,
    EmailDetailModal,
    LineChart,
    TemplateUploadFile,
    RecycleScroller
  },
  data() {
    return {
      loading: false,
      context2: '',
      keyword: [],
      searchContextList: [],
      queryParam: {
        con: '',
      },
      //查询数据范围
      rangeDate: [],
      compareData: [],
      overviewCardObj:{},
      schoolMood: [],
      loadingChart: false,
      loadingMoodChart: false,
      contrastInputStatus: false,
      gradeTrendsRanking: [],
      classTrendsRanking: [],
      careTrendsRanking: [],
      careAverage: {},
      studentActivity: [],
      parentVisit: [],
      schoolMoodSwings: [],
      scoreData: [
        {
          type: '2024-01-09',
          语文: 86,
          数学: 89,
          英语: 89,
          物理: 95,
          化学: 87,
        },
        {
          type: '2024-01-10',
          语文: 82,
          数学: 88,
          英语: 94,
          物理: 88,
          化学: 95,
        },
        {
          type: '2024-01-11',
          语文: 92,
          数学: 92,
          英语: 90,
          物理: 88,
          化学: 89,
        },
        {
          type: '2024-01-12',
          语文: 89,
          数学: 90,
          英语: 92,
          物理: 90,
          化学: 87,
        },
      ],
      otherScoreData: [
        {
          type: '2024-01-01',
          体育: 95,
          美术: 90,
        },
        {
          type: '2024-01-02',
          体育: 93,
          美术: 93,
        },
        {
          type: '2024-01-03',
          体育: 95,
          美术: 97,
        },
        {
          type: '2024-01-04',
          体育: 98,
          美术: 93,
        },
        {
          type: '2024-01-05',
          体育: 95,
          美术: 94,
        },
      ],
      sexData: [
        {
          type: '2024-01-01',
          男生: 22,
          女生: 32,
        },
        {
          type: '2024-01-02',
          男生: 33,
          女生: 27,
        },
        {
          type: '2024-01-03',
          男生: 34,
          女生: 33,
        },
        {
          type: '2024-01-04',
          男生: 25,
          女生: 30,
        },
        {
          type: '2024-01-05',
          男生: 29,
          女生: 30,
        },
      ],
      ageData: [
        {
          type: '2024-01-01',
          '10~12': 33,
          '12~14': 30,
          '14~16': 31,
        },
        {
          type: '2024-01-02',
          '10~12': 28,
          '12~14': 26,
          '14~16': 29,
        },
        {
          type: '2024-01-03',
          '10~12': 29,
          '12~14': 27,
          '14~16': 28,
        },
        {
          type: '2024-01-04',
          '10~12': 27,
          '12~14': 22,
          '14~16': 29,
        },
        {
          type: '2024-01-05',
          '10~12': 30,
          '12~14': 32,
          '14~16': 28,
        },
      ],
      moodField: ['愉悦指数', '关爱名单愉悦指数'],
      volatilityIndex: ['波动指数'],
      searchItem: [],
      searchItemColor: [],
      parentFollowList: {
        title: '家长关注情况',
        columns: [
          {
            title: '关爱度',
            dataIndex: 'care_list',
            align: 'center',
            customRender: (_, record) => {
              return record.care_list ? <img style="width: 18px;height: 18px;" src={require('@/assets/love.png')}/> : ''
            },
          },
          {
            title: '姓名',
            dataIndex: 'name',
            align: 'center',
          },
          {
            title: '家长访问次数',
            dataIndex: 'cnt',
            align: 'center',
            customHeaderCell: () => {
              return {
                style: {
                  minWidth: '200px',
                },
              }
            },
            customCell: () => {
              return {
                style: {
                  minWidth: '200px',
                },
              }
            },
            sorter: (a, b) => a.cnt - b.cnt,
          },
          {
            title: '操作',
            dataIndex: 'phoneEmail',
            align: 'center',
            scopedSlots: { customRender: 'phoneEmail' },
          },
        ],
        tableData: [],
      },
      classEmotions: {
        title: '班级情绪趋势排名',
        columns: [
          {
            title: '排名',
            dataIndex: 'ranking',
            scopedSlots: { customRender: 'ranking' },
          },
          {
            title: '班级',
            dataIndex: 'class',
          },
          {
            title: '愉悦指数',
            dataIndex: 'pleasureIndex',
            defaultSortOrder: 'descend',
            sorter: (a, b) => {
              return a.pleasureIndex - b.pleasureIndex
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
        ],
        tableData: [],
      },
      recentMoodLowList: {
        title: '昨日不开心学生',
        columns: [
          // {
          //   title: '排名',
          //   dataIndex: 'ranking',
          //   align: 'center',
          //   width: 60,
          // },
          // {
          //   title: '年级',
          //   dataIndex: 'name',
          //   customRender: (text) => {
          //     return <div style="min-width: 120px;">{text}</div>
          //   }
          // },
          {
            title: '姓名',
            dataIndex: 'name',
            align: 'center',
          },
          {
            title: '情绪指数',
            align: 'center',
            dataIndex: 'mood_score',
            sorter: (a, b) => a.mood_score - b.mood_score,
          },
          {
            title: '操作',
            dataIndex: 'recentMoodLow',
            align: 'center',
            scopedSlots: { customRender: 'recentMoodLow' },
          },
        ],
        tableData: [],
      },
      mainCareList: {
        title: '重点关爱名单',
        columns: [
          {
            title: '排名',
            dataIndex: 'ranking',
            // slots: { title: 'customTitle' },
            // scopedSlots: { customRender: 'ranking' },
          },
          {
            title: '班级',
            dataIndex: 'student_class',
          },
          {
            title: '名字',
            dataIndex: 'name',
          },
          {
            title: '提醒次数',
            dataIndex: 'warn',
            sorter: (a, b) => a.warn - b.warn,
          },
          {
            title: '愉悦指数',
            dataIndex: 'pleasureIndex',
            sorter: (a, b) => a.pleasureIndex - b.pleasureIndex,
          },
          {
            title: '情绪趋势',
            dataIndex: 'emotionalTrends',
            scopedSlots: { customRender: 'emotionalTrends' },
          },
        ],
        tableData: [],
      },
      grid: { top: '10%', bottom: '25%', left: '12%', right: '12%' },
    }
  },
  created() {
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.loadData()
    this.getSearchKeyword()
    this.getParentPay()
  },
  methods: {
    getCardNum(){
      console.log('班级信息：', this.queryParam.classId)
      getAction('/statistic/classMoodHeader', {
        classId: this.queryParam.classId
      }).then(res => {
        if(res.success){
          console.log('res', res)
          const { careStudent, classDynamics, psychologyEvaluating, remindStudent } = res.result
          this.overviewCardObj = {
            careStudent: careStudent.careStudent,
            waitingCareStudent: careStudent.waitingCareStudent,
            activityCount:classDynamics.activityCount,
            happyCount: classDynamics.happyCount,
            moodCount: classDynamics.moodCount,
            handlingReminders:remindStudent.handlingReminders,
            moodReminder:remindStudent.moodReminder,
            assessmentCount:psychologyEvaluating.assessmentCount,
            planCount:psychologyEvaluating.planCount,
          }
        }
      })
    },
    // 查询事件
    async chaDate() {
      this.contrastInputStatus = false
      this.searchItem = []
      this.context2 = ''
      // 重新加载数据
      this.getCardNum()
      await this.loadData()
    },
    // 添加对比
    addCompareData(params) {
      // console.log('添加对比参数', {...this.queryParam, ...params});
      this.loadingChart = true
      getAction('/statistic/compareData', {...this.queryParam, ...params}).then((res) => {
        if (res.success) {
          this.compareData = res.result
          // this.schoolMood.push(this.compareData)
          const { lineData, filedList } = addLineCompare(this.schoolMood, this.moodField, this.compareData)
          this.schoolMood = lineData
          this.moodField =  filedList
        }
      }).finally(() => {
        this.loadingChart = false
      })
    },
    async loadData() {
      getAction('/statistic/classTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          const classData = res.result.sort((a, b) => b.total - a.total).map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
              class: item.name,
              pleasureIndex: item.total,
            }
          })
          this.$set(this.classEmotions, 'tableData', classData)
        }
      })
      getAction('/aigoes/schoolClass/classNoHappy', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          console.log('昨日不开心学生--', res.result)
          const classData = res.result.map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
              name: item.student_name,
              id: item.student_id,
            }
          })
          this.$set(this.recentMoodLowList, 'tableData', classData)
        }
      })
      getAction('/statistic/careTrendsRanking', this.queryParam).then((res) => {
        console.log(res)
        if (res.success) {
          this.careAverage = res.result.average
          const careData = res.result.ranking.sort((a, b) => b.total - a.total).map((item, index) => {
            return {
              ...item,
              ranking: index + 1,
              pleasureIndex: item.total,
              id: item.student_id,
            }
          })
          // console.log('重点关爱名单--', careData)
          this.$set(this.mainCareList, 'tableData', careData)
        }
      })
      this.getSchoolChangeTrend()
      this.getStuPraCompare(0)
      this.getVarianceUndulateTrend()
    },
    // 获取校园变化趋势折线图数据
    getSchoolChangeTrend() {
      this.loadingChart = true
      getAction('/statistic/schoolMoodTrend', this.queryParam).then((res) => {
        if (res.success) {
          const { filedList, lineData } = handleLineChartData(res.result)
          // console.log('折线图--', filedList, lineData);
          this.schoolMood = lineData
          this.moodField =  filedList
        }
      }).finally(() => {
        this.loadingChart = false
      })
    },
    getStuPraCompare() {
      this.loadingMoodChart = true
      //学生活跃情况
      getAction('/statistic/studentActivityTrend', this.queryParam).then((res) => {
        // console.log('学生活跃情况：', res.result)
        if (res.success) {
          this.studentActivity = res.result.length ? res.result.map(item => ({
            type: item.type,
            '学生活跃度': item.activity
          })) : []
        }
      })
      //家长访问情况
      getAction('/statistic/parentVisitTrend', this.queryParam).then((res) => {
        if (res.success) {
          this.parentVisit = res.result.length ? res.result.map(item => ({
            type: item.type,
            '家长活跃度': item.visit
          })) : []
        }
      })
    },
    getVarianceUndulateTrend() {
      this.loadingMoodChart = true
      console.log('queryParam参数', this.queryParam)
      // 校园情绪波动指数
      getAction('/statistic/varianceUndulateTrend', this.queryParam).then((res) => {
        console.log('校园情绪波动指数', res.result)
        if (res.success) {
          this.schoolMoodSwings = res.result
        }
      }).finally(() => {
        this.loadingMoodChart = false
      })
    },

    getGradeClassWarnNumTrend(type, record) {
      this.loadingChart = true
      const baseParam = { beginDate: this.queryParam.beginDate, endDate: this.queryParam.endDate, name: record.name }
      let query = {}
      switch(type) {
        case 0:
          query = {...this.queryParam}
          break;
        case 2:
          query = {...baseParam, classId: record.class_id}
          break;
      }
      getAction('/statistic/schoolMoodTrend', query).then(res => {
        if (res.success) {
          const { filedList, lineData } = handleLineChartData(res.result)
          console.log('点击班级--', filedList, lineData);
          this.schoolMood = lineData
          this.moodField =  filedList
        }
      }).finally(() => {
        this.loadingChart = false
      })
    },
    //修改时间范围
    onRangeChange(dates, dateString) {
      this.rangeType = 'range'
      this.rangeDate = dates
      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
      this.moodField= ['愉悦指数', '关爱名单愉悦指数'],
        this.searchItem = []
      this.loadData()
      this.getSearchKeyword()
    },
    setDefaultClass(record){
      this.$set(this.queryParam, 'classId', record[0].value)
      this.getCardNum()
    },
    getSearchKeyword() {
      getAction('/statistic/getKeyword', this.queryParam).then((res) => {
        if (res.success) {
          this.searchContextList = res.result
          this.keyword = res.result
        }
      })
    },
    handleSearch: simpleDebounce(function(value) {
      this.queryParam.con = value || ''
      if (!this.searchContextList.length) {
        this.getSearchKeyword()
      } else {
        this.keyword = value ? this.searchContextList.filter(item => item.name.includes(value)) : this.searchContextList
      }
    }, 300),
    handleSelect(value) {
      let currItem = this.keyword.find((i) => i.period_id == value)
      this.$set(this.queryParam, 'crux', currItem.name)
      this.$set(this.queryParam, 'id', value)
      if (value) {
        if (!this.searchItem.includes(this.queryParam.crux)) {
          this.searchItem.push(this.queryParam.crux)
          this.searchItemColor.push(randomColor())
        }
        this.context2 = ''
        this.addCompareData({dataType: currItem.dataType})
      }
      this.contrastInputStatus = false
      this.keyword = this.searchContextList
    },
    getParentPay(record) {
      const params = { beginDate: this.queryParam.beginDate, endDate: this.queryParam.endDate, classId:this.queryParam.classId }
      getAction('/statistic/parentVisitList', params).then((res) => {
        if (res.success) {
          this.$set(this.parentFollowList, 'tableData', res.result)
        }
      })
    },
    deleteBtn(item) {
      const lineData = deleteLineCompare(this.schoolMood, item)
      const idx_s = this.searchItem.indexOf(item)
      this.searchItem.splice(idx_s, 1)
      this.searchItemColor.splice(idx_s, 1)
      const idx = this.moodField.indexOf(item)
      if(idx == -1) return
      this.moodField.splice(idx, 1)
      this.schoolMood = lineData
    },
    addContrast() {
      this.contrastInputStatus = true
    },
    // 添加事件
    addEventClick() {
      this.$refs.addEventModal.show(this.schoolMood, this.moodField)
    },
    // 刷新标注
    refreshMarked(record) {
      const porintIndex = this.schoolMood.findIndex(item => item[record.filed + 'id'] == record.id && item.type == record.type)
      if (porintIndex != -1) {
        const incident = record.filed + 'incident'
        this.$set(this.schoolMood[porintIndex], incident, record['incident'])
        this.schoolMood = [...this.schoolMood]
        // console.log('刷新标注的索引：', porintIndex);
        // console.log('刷新标注后的数据：', this.schoolMood);
      }

    },
    // 查看事件
    viewCareList(record, type) {
      this.$refs.viewKeyPointModal.show(record, type)
    },
    // 获取家长手机号
    getParentPhone(record) {
      this.$refs.phoneDetailModal.show(record)
    },
    getParentEmail(record) {
      this.$refs.emailDetailModal.show(record)
    },
    importTag() {
      this.$refs.templateUploadFile.showModal()
    },
    /**跳转到班级概览详情
     * 1、情绪提醒、已处理提醒详情
     * 2、重点关爱学生数、待关爱学生详情
     * 3、测评计划详情
     * 4、待评估详情
     * 5、愉悦人数详情
     * 6、情绪记录详情
     * 7、校园活动详情
     */
    skipPreviewPage(type, keyword){
      // const routerData = this.$router.resolve({
      //   path: '/school/classManage/ClassOverviewDetail',
      //   query:{
      //     type,
      //     classId: this.queryParam.classId
      //   }
      // })
      // window.open(routerData.href)
      const query = {
        type,
        classId: this.queryParam.classId
      }
      if(keyword) {
        query.keyword = keyword
      }
      this.$router.push({
        path: '/school/classManage/ClassOverviewDetail',
        query: query,
      })
    }
  },
}
</script>

<style lang="less" scoped>
.circle-cust {
  position: relative;
  top: 28px;
  left: -100%;
}
.extra-wrapper {
  line-height: 55px;
  padding-right: 24px;
  text-align: right;

  .extra-item {
    display: inline-block;
    margin-right: 24px;

    a {
      margin-left: 24px;
    }
  }
}

.primaryColor {
  color: #297EDE;
}

.row-box {
  display: flex !important;
  flex-wrap: wrap !important;
}

/* 首页访问量统计 */
.head-info {
  position: relative;
  text-align: left;
  padding: 0 32px 0 0;
  min-width: 125px;

  &.center {
    text-align: center;
    padding: 0 32px;
  }

  span {
    color: rgba(0, 0, 0, 0.45);
    display: inline-block;
    font-size: 0.95rem;
    line-height: 42px;
    margin-bottom: 4px;
  }
  p {
    line-height: 42px;
    margin: 0;
    a {
      font-weight: 600;
      font-size: 1rem;
    }
  }
}
.page-header-index-wide {
  min-height: 100vh !important;
  background-color: #ffffff !important;
}
.tag-col {
  animation: tagAppear 0.3s linear;
}
.select-box {
  position: relative;
  animation: tagAppear 0.3s linear;
}
@keyframes tagAppear {
  from {
    transform: translate(20px, -20px) scale(0.4);
    opacity: 0;
  }
  to {
    transform: translate(0, 0) scale(1);
    opacity: 1;
  }
}
.tag-item {
  width: 100% !important;
  box-sizing: border-box;
  position: relative;
  border: 1px solid #ccc;
  border-radius: 2px;
  height: 30px;
  line-height: 30px;
  padding-left: 5px;
  // 不换行
  .tag-name {
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.delete-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  right: -6px;
}
.select-del-icon {
  cursor: pointer;
  background-color: #c8b9bc;
  color: #fff;
  border-radius: 50%;
  position: absolute;
  top: -1px;
  right: 3px;
}
.line-title {
  font-size: 17px;
  font-weight: 600;
  color: #262626;
  font-family: 'Arial', sans-serif;
}
.leftCardBox {
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  margin: 10px;
  margin-left: 20px;
  ::v-deep {
    .ant-card-body {
      padding-bottom: 0px;
    }
  }
}
.RightCardBox {
  margin: 10px;
  border: 1px solid #e4e4e4;
  border-radius: 10px;
  ::v-deep {
    .ant-card-body {
      padding: 16px;
    }
  }
}
.head-card-box {
  min-height: 135px;
  color: #fff;
  border-radius: 10px;
  padding: 0px 20px;
  .card-title {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
    .detail-icon {
      padding: 4px 16px;
      background: #fff;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
      color: #23CDAD;
    }
  }
}
.card-content {
  display: flex;
  justify-content: space-between;
}
.add-btn {
  background-color: #ffffff;
  color: #1890ff;
  border-color: #1890ff;
  text-shadow: none;
  box-shadow: none;
}
::v-deep {
  .ant-select {
    width: 100% !important;
  }
}
.virtual-list {
  // y轴滚动
  overflow-y: auto;
  // 隐藏x轴滚动条
  overflow-x: hidden;
}
.list-item {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 32px;
  padding-left: 10px;
  cursor: pointer;
}
.list-item:hover {
  background-color: #e6f7ff;
}

.card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.item-value {
  font-size: 28px;
  font-weight: bold;
  margin-bottom: 2px;
}
.item-desc {
  font-size: 14px;
}
.skip-btn {
  &:hover {
    cursor: pointer;
  }
}
</style>

